import { Component } from '@angular/core';
import {
  SingleSelectGridFilterDirective
} from '@app/pcs/shared/containers/search-results-grid/filters/single-select-grid-filter.directive';
import { Store } from '@ngrx/store';

/**
 * General filter component which allows selection of distinct values from the provided property of the object.
 */
@Component({
  template: `
    <pcs-single-select [disabled]="showOnlyRowsWithNoOptions"
                       [selected]="selectedOption"
                       [options]="options$ | async"
                       [displayProperty]="props.displayProperty"
                       (selectionChanged)="onSelectionChanged($event)">
    </pcs-single-select>

    <pcs-checkbox *ngIf="props.showRowsWithNoOptions"
                  class="mt-2"
                  inputId="showRowsWithNoOptions"
                  [label]="props.showRowsWithNoOptionsLabel"
                  [checked]="showOnlyRowsWithNoOptions"
                  (selectionChanged)="onShowOnlyRowsWithNoOptionsChanged($event)">
    </pcs-checkbox>
  `
})
export class SingleSelectGridFilterComponent extends SingleSelectGridFilterDirective<any> {

  constructor(store: Store<any>) {
    super(store);
  }

}
